export class TokenRequest {
    constructor(user: string, pass: string) {
        this.username = user;
        this.password = pass;
    }
    username: string;
    password: string;
}